import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Historia } from "@/components/site/Historia";
import { Carta } from "@/components/site/Carta";
import { Vision } from "@/components/site/Vision";
import { Servicios } from "@/components/site/Servicios";
import { Galeria } from "@/components/site/Galeria";
import { BookingForm } from "@/components/site/BookingForm";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Home() {
  return (
    <div className="grain min-h-screen bg-paper text-jungle overflow-x-clip">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Historia />
        <Carta />
        <Vision />
        <Servicios />
        <Galeria />
        <BookingForm />
        {/* SEO architecture map hidden on request; keep component for future SEO work */}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
